import { useEffect } from 'react'

import type { PageGraphSource } from './canvasTypes'
import { nodeFocusStep, usePendingNodeFocus } from './NodeFocusRequestContext'

export function useNodeFocusRequest({
  pageGraphs,
  isActiveTab,
  focus,
}: {
  pageGraphs: PageGraphSource[]
  isActiveTab: boolean
  focus: (nodeId: string) => boolean
}): void {
  const pending = usePendingNodeFocus()
  useEffect(() => {
    if (!pending || !isActiveTab) return
    const step = nodeFocusStep(pending.request, pageGraphs)
    if (step === 'wait') return
    if (step === 'drop' || focus(pending.request.nodeId)) pending.onHandled()
  }, [focus, isActiveTab, pageGraphs, pending])
}
